import { render, staticRenderFns } from "./CMainShapePc.vue?vue&type=template&id=cef97ea8&"
import script from "./CMainShapePc.vue?vue&type=script&lang=js&"
export * from "./CMainShapePc.vue?vue&type=script&lang=js&"
function injectStyles (context) {
  
  var style0 = require("./CMainShapePc.vue?vue&type=style&index=0&id=cef97ea8&prod&lang=scss&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports